import { render, staticRenderFns } from "./OneSubPrivacy.vue?vue&type=template&id=636b3467&"
import script from "./OneSubPrivacy.vue?vue&type=script&lang=js&"
export * from "./OneSubPrivacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports